import axios from 'axios'
import { getHost } from './host'

interface Features {
  use_power_schedules: boolean | null;
  use_rawaudio_schedules: boolean | null;
}

interface Coordinates {
  id: number;
  latitude: string;
  longitude: string;
  zoom: number;
}

interface Site {
  id: string,
  title: string,
  status_box_display: boolean
}
interface PositionData {
  id: string;
  title: string; 
  account_id: number;
  site: Site;
  site_id: string;
  description: string;
  type: string;
  type_id:number;
  subtype: string;
  subtype_id: number;
  timezone: string;
  make: string;
  model: string;
  serial: string;
  coordinates: Coordinates;
  status: StatusData;
  monitor: any;
  limit_exceedance_summary: Array<any>;
  timeperiods: Array<any>;
}

interface StatusData {
  charge_status: string;
  exceedance_level_earlier: string;
  exceedance_level_now: string;
  exceedance_level_total: string;
  exceedance_earlier: number;
  exceedance_now: number;
  exceedance_total: number;
  last_sample: string;
  last_seen: string;
  last_status: string;
  measuring: boolean;
  online_status: string;
  voltage: string;
}
export interface TimePeriodsData {
  days: any;
  end: string;
  end_time: string;
  start: string;
  start_time: string;
  is_live: boolean;
  limits: any;
  nominal_end: string;
  nominal_start: string;
  period_index: number;  
}
export interface PositionTimePeriods {
  data: TimePeriodsData;
}
export interface NodeRebootDetails {
  id: string;
  reboot_day?: string;
  reboot_time?: string;
}
export interface Position {
  data: PositionData;  
}

export async function setFeatures(api_key: string, id: string, features: Features) {

  const bodyFormData = new FormData();
  
  const url = `https://${getHost()}/api/station/${id.toString()}/features`;
  
  bodyFormData.append('use_power_schedules', features.use_power_schedules !== null? features.use_power_schedules.toString() : null);
  bodyFormData.append('use_rawaudio_schedules', features.use_rawaudio_schedules !== null? features.use_rawaudio_schedules.toString() : null);
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<Position>(url, bodyFormData, { headers: headers });
  
  return data
}

export async function getPositions(api_key: string, account_id: any) {
  
  const url = `https://${getHost()}/api/stations`
  
  const params = {  
    account_id: account_id,
    'expand':  ['monitor', 'site', 'status', 'coordinates']
  }

  const { data } = await axios.get<Position[]>(
    url,
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    });
    
    return data.map(position => { return { ...position.data }})
}

export async function getPositionTimeperiods(api_key: string, station_id: string) {
  
  const url = `https://${getHost()}/api/station/${station_id.toString()}/time_periods`;
  
  const params = {    
    // current_period = period now, current_day = all periods
    default_timerange: 'current_day',
    depth: 'timebases'
  }
  
  const { data } = await axios.get(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  
  
  return data.data
}

export async function putNodeRebootDetails(api_key: string, node: NodeRebootDetails){

  /**
   * Since this is a PUT reqest, it should be noted that parameter values should be
   * in type - x-www-form-urlencoded
   */

  const url = `https://${getHost()}/api/station/${node.id.toString()}/reboot`

  const encodedParams = new URLSearchParams();
  encodedParams.append('reboot_day', node.reboot_day);
  encodedParams.append('reboot_time', node.reboot_time);
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/x-www-form-urlencoded'
  };

  const { data } = await axios.put(url, encodedParams, { headers: headers });

  return data

}

export async function getPositionSamples(api_key: string, station_id: string){
  const url = `https://${getHost()}/api/station/${station_id.toString()}/samples`;

  const params = {    
    default_timerange: 'current_period',
  }
  const { data } = await axios.get(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  return data.data
}